// Controls display of collapsing sections on product page and collection FAQs
// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function() {
  // Handle product page accordions (existing functionality)
  var acc = document.getElementsByClassName("sg-accordion");
  
  for (var i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
  
  // Handle collection FAQ accordions (new functionality)
  var faqQuestions = document.querySelectorAll('.faq-question');
  
  faqQuestions.forEach(function(question) {
    question.addEventListener('click', function() {
      this.classList.toggle("active");
      var answer = this.nextElementSibling;
      if (answer.style.maxHeight) {
        answer.style.maxHeight = null;
      } else {
        answer.style.maxHeight = answer.scrollHeight + "px";
      }
    });
  });
});